import React, { useRef, useState } from "react";
import * as THREE from "three";
import { useEffect } from "react";
import { useUI } from "../../stores/useUI";


interface RotatablePlanetProps {
  children: React.ReactNode;
  isDragging: boolean;
  setIsDragging: (isDragging: boolean) => void;
}
// Rotatable Planet Component
export default function RotatablePlanet({ children, isDragging, setIsDragging }: RotatablePlanetProps) {
  const groupRef = useRef<THREE.Group>(null);
  const [previousMousePosition, setPreviousMousePosition] = useState({ x: 0, y: 0 });
  const globePosition = useUI((state) => state.globePosition);
  const setGlobePosition = useUI((state) => state.setGlobePosition);
  // const setHoveredMapId = useUI((state) => state.setHoveredMapId);

  const isPointerDown = useRef(false);
  // const [isPointerDown, setIsPointerDown] = useState(false);
  
  const handlePointerDown = (event: any) => {
    // setHoveredMapId(null); // Reset hovered map ID when starting to drag
    

    isPointerDown.current = true;
    setIsDragging(true);
    setPreviousMousePosition({ x: event.clientX, y: event.clientY });
  };
  
  const handlePointerUp = () => {
    setIsDragging(false);
    isPointerDown.current = false;
  };

  useEffect(() => {
    if (groupRef.current) {
      groupRef.current.rotation.x = globePosition.x;
      groupRef.current.rotation.y = globePosition.y;
    }
  }, []);
  
  const handlePointerMove = (event: any) => {
    if (!groupRef.current || !isPointerDown.current) return;

    const deltaX = event.clientX - previousMousePosition.x;
    const deltaY = event.clientY - previousMousePosition.y;
    
    // Rotate planet based on mouse movement
    groupRef.current.rotation.y += deltaX * 0.001;
    groupRef.current.rotation.x += deltaY * 0.001;
    
    // Limit rotation on X axis to prevent flipping
    groupRef.current.rotation.x = Math.max(
      Math.min(groupRef.current.rotation.x, Math.PI / 4),
      -Math.PI / 4
    );
    
    setPreviousMousePosition({ x: event.clientX, y: event.clientY });
    setGlobePosition({ x: groupRef.current.rotation.x, y: groupRef.current.rotation.y });
  };
  
  useEffect(() => {
    const handleGlobalPointerMove = (event: MouseEvent) => handlePointerMove(event);
    const handleGlobalPointerUp = () => handlePointerUp();
    
    if (isPointerDown.current) {
      document.addEventListener('mousemove', handleGlobalPointerMove);
      document.addEventListener('mouseup', handleGlobalPointerUp);
    }
    
    return () => {
      document.removeEventListener('mousemove', handleGlobalPointerMove);
      document.removeEventListener('mouseup', handleGlobalPointerUp);
    };
  }, [isPointerDown.current, previousMousePosition]);
  
  return (
    <group 
      ref={groupRef} 
      onPointerDown={handlePointerDown}
      position={[0, -42, 0]}
    >
      {children}
    </group>
  );
}